'use strict';
const mmWidgets = require('./mm-widgets'),
	goldSharingDescriptions = require('../models/gold-sharing-descriptions'),
	errorDescriptions = {
		'is-owner': 'Owns this map',
		'domain_account': 'Sharing with Organisational accounts is not currently supported'
	};
require('./section-handler-widget');
require('./gold-map-shared-with-widget');
mmWidgets.fn.goldMapSharingListWidget = function (mapSharingModel) {
	if (!mapSharingModel) {
		throw new Error('invalid-args');
	}

	return mmWidgets.each(this, function () {
		const element = this,
			errorContainer = element.find('[data-mm-role~=shared-error-container]'),
			errorTemplate = element.find('[data-mm-role~=shared-error-template]').detach(),
			listContainer = element.find('[data-mm-role~="sharing-list-container"]'),
			template = element.find('[data-mm-role~=shared-with-template]').detach(),
			showSharingList = (context) => {
				let sharedShown = 0;
				listContainer.empty();
				if (!context.hasShareList) {
					element.showSection('no-shared-emails');
					return;
				}
				context.sharingList.forEach((shareItem) => {
					sharedShown += 1;
					template.clone().goldMapSharedWithWidget(shareItem, goldSharingDescriptions[shareItem.role] || shareItem.role, mapSharingModel).appendTo(listContainer);
				});
				if (sharedShown) {
					element.showSection('show-list');
				} else {
					element.showSection('no-shared-emails');
				}

			},
			showErrorList = (context) => {
				let errorsShown = 0;
				errorContainer.empty();
				Object.keys(context.errors).forEach((errorEmail) => {
					const error = context.errors[errorEmail],
						errorDescription = error && errorDescriptions[error.reason];
					if (!errorDescription) {
						return;
					}
					errorsShown += 1;
					errorTemplate.clone().text(error.email + ': ' + errorDescription).appendTo(errorContainer);
				});
				if (errorsShown) {
					element.showSection('show-save-errors');
				} else {
					showSharingList(context);
				}
			},
			onContext = (context) => {
				if (context.tab !== 'gold') {
					return;
				}
				if (context.activity) {
					return;
				}
				if (context.hasErrors) {
					showErrorList(context);
					return;
				}
				showSharingList(context);
			};
		element.on('show', () => {
			mapSharingModel.addEventListener('context', onContext);
		});
		element.on('hide', () => {
			mapSharingModel.removeEventListener('context', onContext);
		});

	});
};
